import React, { ReactNode } from 'react';
import { bemGenerator } from '@prisjakt/ui-base';
import PanelHeader from '@prisjakt/ui-panel-header';

import './panel.scss';

const styles = bemGenerator('pj-ui-panel', ['row', 'grid', 'table', 'content']);

type Props = {
  header?: ReactNode;
  footer?: ReactNode;
  layoutMode: 'row' | 'grid' | 'table';
  flexGrid?: boolean;
  flexRow?: boolean;
  children?: ReactNode;
  lines?: boolean;
  title?: string;
  spacing?: boolean;
  margin: 'top' | 'bottom' | 'both' | 'none';
  'data-test-type'?: string;
};

const Panel = ({
  header,
  footer,
  children,
  layoutMode = 'row',
  flexGrid = true,
  flexRow,
  title,
  lines,
  spacing,
  margin = 'bottom',
  ...props
}: Props) => (
  <div
    className={styles.block.withModifier({
      'margin-top': ['top', 'both'].includes(margin),
      'margin-bottom': ['bottom', 'both'].includes(margin),
    })}
    data-test="Panel"
    data-test-type={props['data-test-type']}
  >
    {title && !header && <PanelHeader title={title} />}
    {header}
    <div
      className={styles[layoutMode].withModifier({
        lines,
        spacing,
        'flex-grid': flexGrid,
        'flex-row': flexRow,
      })}
    >
      {children}
    </div>
    {footer && <div>{footer}</div>}
  </div>
);

export default Panel;
